export const styles = {
  container: (theme) => ({
    color: 'kit.text.main',
    backgroundColor: 'kit.background.gray',
    borderRadius: '16px',
    padding: 0,
    [theme.breakpoints.up('md')]: {
      padding: '48px 70px 48px 30px',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '48px 0',
      '::before': {
        borderRadius: '16px',
        margin: 'auto',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'kit.background.gray',
        content: "''",
        position: 'absolute',
        width: 'calc(100% - 60px)',
        height: '100%',
      },
    },
  }),
  title: (theme) => ({
    fontSize: '22px',
    lineHeight: '26px',
    marginBottom: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    textTransform: 'none',
    [theme.breakpoints.up('md')]: {
      fontSize: '24px',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '34px',
      marginBottom: '24px',
      position: 'relative',
    },
  }),
  description: (theme) => ({
    fontSize: '14px',
    lineHeight: '21px',
    marginBottom: '12px',
    [theme.breakpoints.up('md')]: {
      fontSize: '16px',
      lineHeight: '23px',
      marginBottom: '14px',
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: '18px',
      lineHeight: '26px',
      marginBottom: '16px',
      position: 'relative',
    },
    ':last-child': {
      marginBottom: 0,
    },
  }),
  imgContainer: (theme) => ({
    [theme.breakpoints.up('lg')]: {
      position: 'relative',
    },
  }),
  imgBox: (theme) => ({
    display: 'none',
    overflow: 'hidden',
    borderRadius: '8px',
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      position: 'relative',
      width: '567px',
      height: '338px',
    },
  }),
};
